/* eslint-disable @typescript-eslint/no-explicit-any */
const callbacks = new Set<any>();

let listenerStarted = false;
let userInteracted = false;

function userInteractionHandler() {
  if (!userInteracted) {
    userInteracted = true;
    for (const cb of callbacks) {
      cb(true);
    }
    callbacks.clear();
  }
  document.body.removeEventListener('click', userInteractionHandler);
  document.body.removeEventListener('keydown', userInteractionHandler);
}

function startInitialStateListener() {
  if (listenerStarted) {
    return;
  }
  listenerStarted = true;

  if (typeof window === 'undefined' || window.document?.body == null) {
    // If no document body, assume interaction has already happened
    userInteracted = true;
    return;
  }
  if (performance.now() > 10000) {
    // If more than 10s have passed since page load, assume interaction has already happened
    userInteracted = true;
    return;
  }
  userInteracted = false;
  document.body.addEventListener('click', userInteractionHandler);
  document.body.addEventListener('keydown', userInteractionHandler);
}

function addInitialStateCallback(cb: any) {
  callbacks.add(cb);
}

function removeInitialStateCallback(cb: any) {
  callbacks.delete(cb);
}
function isInitialState() {
  return !userInteracted;
}

function overrideInitialStateForTests(value: boolean) {
  if (typeof window !== 'undefined' && window.document != null) {
    document.body.removeEventListener('click', userInteractionHandler);
    document.body.removeEventListener('keydown', userInteractionHandler);
  }
  listenerStarted = true;
  userInteracted = !value;
}

export {
  startInitialStateListener,
  overrideInitialStateForTests,
  addInitialStateCallback,
  removeInitialStateCallback,
  isInitialState,
};
